import { render } from "./escola_visualizar.vue?vue&type=template&id=31c278dc"
import script from "./escola_visualizar.vue?vue&type=script&lang=js"
export * from "./escola_visualizar.vue?vue&type=script&lang=js"

import "./escola_visualizar.vue?vue&type=style&index=0&id=31c278dc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__